import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { Lead, LeadScreenStore } from '../../../stores/LeadStore';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Grid from '@mui/material/Grid';
import DoActivityLeadInformation from './DoActivityLeadInformation';
import { LeadDataFormater } from 'src/features/leads/view/LeadDataFormater';
import { LeadAccountComponent } from 'src/features/leads/view/LeadAccountComponent';
import LocalFireDepartmentTwoTone from '@mui/icons-material/LocalFireDepartmentTwoTone';
import QuestionAnswerTwoToneIcon from '@mui/icons-material/QuestionAnswerTwoTone';
import DoActivityAccountInfo from './DoActivityAccountInfo';
import DoActivityCompanyInfo from './DoActivityCompanyInfo';
import DoActivitySprintInfo from './DoActivitySprintInfo';
import DoActivityHistoryInfo from './DoActivityHistoryInfo';
import DoActivityMessaging from './DoActivityMessaging';
import DoActivityCadenceInfo from './DoActivityCadenceInfo';
import DoActivityOutcomes from './DoActivityOutcomes';
import DoActivityOutboundPhoneCall from './DoActivityOutboundPhoneCall';
import DoActivityOutboundEmail from './DoActivityOutboundEmail';
import DoActivityOutboundSocialMedia from './DoActivityOutboundSocialMedia';
import DoActivityOutboundSMS from './DoActivityOutboundSMS';
import HotLeadToggleIcon from '../../common/HotLeadToggleIcon';
import DoActivityOutboundWhatsApp from './DoActivityOutboundWhatsApp';
import DoActivityInboundPhoneCall from './DoActivityInboundPhoneCall';
import DoActivityInboundEmail from './DoActivityInboundEmail';
import DoActivityInboundSocialMedia from './DoActivityInboundSocialMedia';
import DoActivityInboundSMS from './DoActivityInboundSMS';
import DoActivityContactRates from './DoActivityContactRates';
import DoActivityNotesTasks from './DoActivityNotesTasks';
import DoActivityDiscoveryCall from './DoActivityDiscoveryCall';
import Close from '@mui/icons-material/Close';
import SectionAppBar from '../../../v2/components/Section/SectionAppBar';
import CloseButton from '../../../v2/components/Button/CloseButton';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

type Props = {
    open: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    lead: Lead;
};

export default function ActivityDialog({ open, onConfirm, onCancel, lead }: Props) {
    const handlePreviousLead = () => {
        LeadScreenStore.update((s) => {
            s.loadPreviousLead = true;
        });
    };

    const handleNextLead = () => {
        LeadScreenStore.update((s) => {
            s.loadNextLead = true;
        });
    };

    return (
        <Dialog
            sx={{ padding: 0 }}
            fullScreen
            open={open}
            onClose={onCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle sx={{ padding: 0 }}>
                <Box sx={{ padding: 0, margin: 0 }}>
                    <SectionAppBar
                        title={
                            <Box>
                                <IconButton title="Previous Lead" onClick={handlePreviousLead}>
                                    <NavigateBeforeIcon />
                                </IconButton>
                                Activity Execution for lead: {lead.firstName} {lead.lastName}
                                <IconButton title="Next Lead" onClick={handleNextLead}>
                                    <NavigateNextIcon />
                                </IconButton>
                            </Box>
                        }
                        subTitle={
                            lead.meaningfulInteraction ? (
                                <Tooltip title="Has a Meaningful Interaction">
                                    <QuestionAnswerTwoToneIcon sx={{ color: 'LightSeaGreen' }} />
                                </Tooltip>
                            ) : (
                                ''
                            )
                        }
                        buttons={
                            <>
                                <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                    <LeadDataFormater
                                        labelText="Stage:"
                                        valueText={lead.leadStage != null ? lead.leadStage.name : ''}
                                        textColor={lead.leadStage != null ? lead.leadStage.stageColor : ''}
                                        errorText="-Stage is missing-"
                                        chipHeight={20}
                                        chipFontSize="0.875rem"
                                        chipfontWeight={500}
                                        isChip={true}
                                    />
                                </Box>

                                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <HotLeadToggleIcon leadId={lead.id} hotLead={lead.hotLead} />

                                    <CloseButton
                                        title="Close"
                                        data-testid="close-button"
                                        onClick={onCancel}
                                        sx={{
                                            color: 'text.secondary',
                                        }}
                                    >
                                        Close
                                    </CloseButton>
                                </Box>
                            </>
                        }
                    />
                </Box>
            </DialogTitle>
            <DialogContent>
                <PerfectScrollbar options={{ wheelPropagation: true }}>
                    <Grid container spacing={2} justifyContent={'center'}>
                        <Grid item xs={12} md={3} alignItems="flex-start">
                            <Grid container spacing={2} justifyContent={'center'}>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{ pt: 2, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <DoActivityLeadInformation />
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{ pt: 2, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                >
                                    <DoActivityContactRates />
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{ pt: 2, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }}
                                ></Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={9} spacing={2}>
                            <Grid container spacing={2} sx={{ mb: 4 }}>
                                <Grid item xs={12} md={6}>
                                    <DoActivityMessaging />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    {lead.nextActivity.name == 'Outbound Phone Call' && <DoActivityOutboundPhoneCall />}
                                    {lead.nextActivity.name == 'Outbound Email' && (
                                        <DoActivityOutboundEmail key={lead.id} />
                                    )}
                                    {lead.nextActivity.name == 'Outbound Social Media' && (
                                        <DoActivityOutboundSocialMedia />
                                    )}
                                    {lead.nextActivity.name == 'Outbound SMS' && <DoActivityOutboundSMS />}
                                    {lead.nextActivity.name == 'Outbound WhatsApp' && <DoActivityOutboundWhatsApp />}
                                    {lead.nextActivity.name == 'Inbound Phone Call' && <DoActivityInboundPhoneCall />}
                                    {lead.nextActivity.name == 'Inbound Email' && <DoActivityInboundEmail />}
                                    {lead.nextActivity.name == 'Inbound Social Media' && (
                                        <DoActivityInboundSocialMedia />
                                    )}
                                    {lead.nextActivity.name == 'Inbound SMS' && <DoActivityInboundSMS />}
                                    {lead.nextActivity.name == 'Discovery Call' && <DoActivityDiscoveryCall />}
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4}>
                                    <DoActivityHistoryInfo />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <DoActivityCadenceInfo />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <DoActivityNotesTasks />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </PerfectScrollbar>
            </DialogContent>
            {/*<DialogActions>*/}
            {/*    <Button onClick={onCancel}>Close</Button>*/}
            {/*</DialogActions>*/}
        </Dialog>
    );
}
